<template>
    <save-modal :show="routesIsChanged.length" position="bottom-right" @save="confirm" @cancel="cancel"/>
    <modal-dialog v-model:show="cancelConfirm">
      <div class="confirm-btn-block" >
        <div>Отменить?</div>
        <div>
          <button @click="cencelAll" class="save-button">Да</button>
          <button @click="cancelConfirm=false" class="delete-btn">Нет</button>
        </div>
      </div>
    </modal-dialog>
    
    <div class="content">
      <div>
        <h3>Список маршрутов</h3>
      </div>
      <div class="filters">
        <div class="search-block">
            <label for="search" class="search-label">Поиск: </label>
            <input v-model="search" id="search" type="text" placeholder="Введите текст для поиска" />
        </div>
        <div>
            <select v-model="inAti">
                <option :value="false">Все</option>
                <option :value="true">Выставленные</option>
            </select>
        </div>
        <div>
          <button class="cancel-all" @click="cancelConfirm = true">Отменить все</button>
        </div>
      </div>
      <table class="company-table">
        <thead>
          <tr>
            <th>Выставить</th>
            <th>Маршрут</th>
            <th>Ставка без НДС</th>
            <th>Ставка с НДС</th>
            <th>Изменить без НДС</th>
            <th>Изменить с НДС</th>
            <th>С Даты</th>
            <th>До Даты</th>
            <th>Комментарий</th>
            <th>Сброс корректировки</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="route in filteredData" :key="route.id">
            <td v-if="route.update_status === 'update' || route.update_status === 'delete' "> 
                <font-awesome-icon icon="fa-solid fa-clock" 
                class="icon-select icon-clock"/>
            </td>
            <td v-else-if="!route.in_ati"> 
                <font-awesome-icon 
                @click="setInAti(route.id,true)" 
                icon="fa-solid fa-play" 
                class="icon-select icon-play"/>
            </td>
            <td v-else>
                <font-awesome-icon @click="setInAti(route.id,false)" icon="fa-solid fa-check" class="icon-select icon-check"/>
            </td>
            <td>{{ route.route }}</td>
            <td>{{ route.bid }}</td>
            <td>{{ route.bid_tax }}</td>
            <td class="rate-sum">
              <input class="number-input" :value="route.changed_rate_bid" type="number" @input="e=>updateRoute(e,route.id)" name="changed_rate_bid" />
            </td>
            <td>
              <input class="number-input" :value="route.changed_rate_bid_tax" type="number" @input="e=>updateRoute(e,route.id)" name="changed_rate_bid_tax"/>
            </td>
            <td>
              <input v-if="!route.is_corrected" class="number-input" :value="route.from_dt" type="datetime-local" @input="e=>updateRoute(e,route.id)" name="from_dt"/>
              <p v-else-if="route.from_dt">{{ formatData(route.from_dt) }}</p>
            </td>
            <td>
              <input v-if="!route.is_corrected" class="number-input" :value="route.before_dt" type="datetime-local" @input="e=>updateRoute(e,route.id)" name="before_dt"/>
              <p v-else-if="route.before_dt">{{ formatData(route.before_dt) }}</p>
            </td>
            <td>
              <input class="" :value="route.note" type="text" @input="e=>updateRoute(e,route.id)" name="note"/>
            </td>
            <td>
              <button class="delete-button hover" @click="resetRoute(route.id)">Сброс</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
<script>
import { ref,computed,onMounted,onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';

export default {
    setup() {
      const store = useStore()
      const actualRoute = computed(()=>store.state.ati.routes)
      const search = ref('')
      const inAti = ref(false)
      const cancelConfirm = ref(false)
      const interval = setInterval(() => {
          store.dispatch('ati/getRoutes');
        }, 60000);

      onBeforeUnmount(()=>{
        clearInterval(interval);
      })

      onMounted(() => {
        store.dispatch('ati/getRoutes')
      })

      const formatData = (data) =>{
        return data.split('T')[0]
      }

      const setInAti = (id,status) => {
        store.commit('ati/setInAti',{id,status})
      }

      const filteredData = computed(() => {
        const searchLower = search.value.trim().toLowerCase();
        // Если строка поиска пуста, возвращаем все записи
        if (!search.value.trim() && !inAti.value) {
          return actualRoute.value;
        }else if(inAti.value && !search.value.trim()){
          return store.getters['ati/routeInAti']
        }else if(inAti.value && search.value.trim()){
          return store.getters['ati/routeInAti'].filter((route) => route.route.toLowerCase().includes(searchLower));
        }else{
          return actualRoute.value.filter((route) => route.route.toLowerCase().includes(searchLower));
        }
        
      });

      const confirm = ()=>{
        store.dispatch('ati/updateRoute')
      }

      const cancel = async()=>{
        await store.dispatch('ati/getRoutes')
      }

      const updateRoute = (event,id)=>{
        store.commit('ati/changeWithoutUpdate',{id,value:event.target.value,name:event.target.name})
      }

      const resetRoute =(id)=>{
        store.dispatch('ati/resetRoute',{id})
      }

      const cencelAll = async()=>{
        await store.dispatch('ati/cencelAll')
        cancelConfirm.value = false
      }
  
      return {
        cancelConfirm,
        cencelAll,
        inAti,
        routesIsChanged: computed(()=> store.getters['ati/changedRoutes']),
        resetRoute,
        updateRoute,
        cancel,
        confirm,
        setInAti,
        formatData,
        search,
        filteredData
      };
    },
}
</script>
  
<style scoped>

.content {
  padding-left: 14px;
  font-size: 12px;
}

.company-table {
    margin-top: 23px;
    margin-right: 20px;
    border-collapse: collapse;
}


.company-table th{
  text-align: center;
  padding: 10px;
  border: 1px solid #ccc;
}
.company-table td {
    text-align: center;
    padding: 3px 10px;
    border: 1px solid #ccc;
}

.company-table th {
    font-weight: bold;
}

.rate-sum{
    min-width: 100px;
}

.number-input {
    width: 95px;
    padding: 3px;
}

.delete-button{
    padding: 5px;
    border-radius: 4px;
    border: 1px solid #ccc;
    color: white;
    background-color: rgba(0,123,255,0.8);
}

.disabled-button{
    padding: 5px;
    border-radius: 4px;
    border: 1px solid #ccc;
}
.hover:hover {
    cursor: pointer;
}

.search-block{
    margin-bottom: 10px;
}

.search-label{
    font-weight: bold;
    margin-right: 5px;
}

#search{
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 200px;
}

h3 {
    margin-top: 20px;
    text-align: center;
}
.filters{
    display: flex;
}

select{
    margin-left: 20px;
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    background-color: white ;
}

.icon-select{
  border-radius: 3px;
  width: 40px;
  height: 18px;
  padding: 1px;
}

.icon-play{
  border: 1px solid #47a01c;
  color: #47a01c;
}

.icon-clock{
  border: 1px solid #dfda34;
  color: #dfda34;
}


.icon-check{
  border: 1px solid #1765ee;
  color: #1765ee;
}

.cancel-all {
  box-shadow: 4px 3px 5px #c2c1c1;
  padding: 5px;
  border: 2px solid rgba(121,121,121, 1.0);
  border-radius: 5px;
  background-color: rgba(224, 53, 19, 0.6);
  margin-left: 20px;
}

.save-button {
  margin-top: 10px;
  margin-right: 15px;
  margin-top: 2px;
  padding: 5px 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.delete-btn {
  margin-top: 10px;
  padding: 5px 8px; 
  border: 1px solid #C33245;
  border-radius: 4px;
  background-color: #C33245;
  color: #fff;
  cursor: pointer;
}


.confirm-btn-block{
  width: 150px;
  padding: 5px;
  text-align: center;
}
  </style>
  